import { ReceivableFilter } from "../../types/receivableFilter.types";
import receivableApi from "../api/receivableTable.api";

const ReceivableTableService = {
  /**
   * 📊 Lista las cuentas por cobrar con filtros y paginación
   * POST /api/receivables/search?page=0&size=10&sort=dueDate,desc
   */
  getFiltered: async (
    filters: ReceivableFilter,
    page = 0,
    size = 10,
    sort = "dueDate,desc"
  ) => {
    const response = await receivableApi.addCustom(
      `/search?page=${page}&size=${size}&sort=${sort}`,
      filters
    );

    return response.data;
  },

  /**
   * 💰 Obtener resumen para registrar pago
   * GET /api/receivables/{id}/payment-summary
   */
  getPaymentSummary: async (id: number) => {
    const response = await receivableApi.fetchCustom(
      `/${id}/payment-summary`
    );

    return response.data;
  },

  /**
   * 🔥 Obtener cuentas pendientes por cliente
   * GET /api/receivables/customer/{customerId}/pending?search=
   */
  getPendingByCustomer: async (
    customerId: number,
    search?: string
  ) => {
    const query = search?.trim()
      ? `?search=${encodeURIComponent(search)}`
      : "";

    const response = await receivableApi.fetchCustom(
      `/customer/${customerId}/pending${query}`
    );

    return response.data;
  },

  /**
 * 🔥 Obtener cuentas para historial de pagos por cliente
 * GET /api/receivables/customer/{customerId}/payment-history?search=
 */
  getPaymentHistoryByCustomer: async (
    customerId: number,
    search?: string
  ) => {
    const query = search?.trim()
      ? `?search=${encodeURIComponent(search)}`
      : "";

    const response = await receivableApi.fetchCustom(
      `/customer/${customerId}/payment-history${query}`
    );

    return response.data;
  },
};

export default ReceivableTableService;